/**
 * 定期便 CTA のクリックを GA4 に送る (2026-07-19).
 *
 * ■ なぜ要るか
 *   Shopify の GA4 連携が送る `add_to_cart` は **チェックアウト画面**
 *   (/checkouts/cn/<id>/ja-jp) で発火する。 実測で確認済み。
 *   そのため「定期便ページを見た人がカートに入れたか」が測れなかった。
 *   → 元ページ (/pages/teikibin) で発火する独自イベントを自前で送る。
 *
 * ■ なぜ gtag を直接呼べるか
 *   このストアは GA4 タグがメインウィンドウに読み込まれており
 *   (googletagmanager.com/gtag/js?id=G-…)、window.gtag が function として使える。
 *   Web Pixel のサンドボックス経由ではないので Custom Pixel を作らなくてよい。
 *   将来サンドボックス専用に変わったら gtag が消えるので、必ず存在確認してから呼ぶ
 *   (無ければ黙って何もしない = 購入導線は絶対に壊さない)。
 *
 * ■ イベント名を固定値にする理由
 *   GA4 の Data API は eventName を標準ディメンションとして返すので、
 *   イベント名さえ固定なら **ETL もスキーマも変更不要**でそのまま
 *   ga4_events_daily / ga4_events_by_page_daily に入る。
 *   パラメータ (item_id 等) は GA4 管理画面でカスタムディメンション登録
 *   しない限り Data API には出ない。 集計に使うのは名前だけにしてある。
 *
 * ■ 壊さないための原則
 *   - preventDefault しない。 遷移は必ず元どおり行う
 *   - gtag は sendBeacon で送るのでページ遷移でも落ちにくいが、
 *     仮に送信が失敗しても購入には一切影響しない
 *   - 例外は握り潰す (計測のために買い物を止めない)
 */
(function () {
  "use strict";

  // 🔴 冪等化。 fn-subscribe は 1 ページに 2 回描画される (山芋 / おから) ため
  //    同じ src の <script> が 2 本出る。 ブラウザは同一 src でも**両方実行する**ので、
  //    ガードしないとリスナーが 2 つ付いてイベントが二重計上される。
  if (window.__fnSubscribeTrackingLoaded) return;
  window.__fnSubscribeTrackingLoaded = true;

  var EVENT_NAME = "teikibin_subscribe_click";
  var SELECTOR = ".fn-sub__cycle";

  function send(link) {
    if (typeof window.gtag !== "function") return;
    try {
      window.gtag("event", EVENT_NAME, {
        item_id: link.getAttribute("data-variant-id") || "",
        item_name: link.getAttribute("data-product-label") || "",
        pack: link.getAttribute("data-pack") || "",
        cycle: link.getAttribute("data-cycle") || "",
        value: Number(link.getAttribute("data-price")) || 0,
        currency: "JPY",
      });
    } catch (e) {
      /* 計測の失敗で購入導線を止めない */
    }
  }

  document.addEventListener(
    "click",
    function (ev) {
      var t = ev.target;
      if (!t || typeof t.closest !== "function") return;
      var link = t.closest(SELECTOR);
      if (link) send(link);
    },
    // capture: 途中で stopPropagation する実装が入っても拾えるようにする
    true
  );
})();
